
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'IntrahepaticBileDuct_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/IntrahepaticBileDuct_TNM.vue